// extracted by mini-css-extract-plugin
export var arrow = "PageLink-module--arrow--8a3ce";
export var link = "PageLink-module--link--4767d";